import React, { useState } from "react";

import Form from "ui/Form";
import { useRoutes } from "utils/routes";
import CreatableSelect from "ui/CreatableSelect";
import PageContent from "ui/PageContent";
import Page from "frame/Page";

type Organization = {
  id: string;
  name: string;
  slug: string;
  status: string;
  billing: boolean;
  linked: boolean;
};

type OrganizationOption = Organization & {
  label: string;
  value: string;
};

const MarketplaceLink = ({
  marketplaceProvider,
  organizations,
}: {
  marketplaceProvider: string;
  organizations: Organization[];
}) => {
  const { marketplaceLink } = useRoutes();
  const [error, setError] = useState(null);
  const [selectedOrg, setSelectedOrg] = useState<OrganizationOption>(null);
  const options = organizations.map((org) => {
    return {
      ...org,
      value: org.id,
      label: org.name,
    };
  });
  const legacyContent = (
    <PageContent
      title="Link existing pganalyze organization"
      pageCategory="marketplace"
      pageName="link"
    >
      <div className="flex-container">
        <div className="form-container">
          <div>
            <p>
              You can link the AWS Marketplace subscription to an existing
              organization.
            </p>
            <p>Please select an organization to link to from the list.</p>
          </div>
          <Form
            id="marketplace_link"
            action={marketplaceLink(marketplaceProvider)}
            method="post"
            insideSection
          >
            <CreatableSelect
              value={selectedOrg}
              options={options}
              onChange={(newOrg) => {
                setError(null);
                if (newOrg.status === "active") {
                  setError(
                    "Unable to select this organization as this organization has an active subscription." +
                      " Please contact support if you would like to change the subscription to the AWS Marketplace with the existing organization.",
                  );
                } else if (!newOrg.billing) {
                  setError(
                    "You do not have a billing permission with this organization required to make changes with this organization.",
                  );
                } else if (newOrg.linked) {
                  setError(
                    "This organization is already linked to a different AWS account.",
                  );
                }
                setSelectedOrg(newOrg);
              }}
            />
            {error && <div className="text-[#C22426] mt-4">{error}</div>}
            <input
              type="hidden"
              name="organization_id"
              value={selectedOrg?.id}
            />
            <div className="mt-4">
              <input
                type="submit"
                name="commit"
                value="Link this organization"
                className="btn btn-success"
                disabled={!selectedOrg || !!error}
              />
            </div>
          </Form>
        </div>
      </div>
    </PageContent>
  );

  return <Page legacyContent={legacyContent} />;
};

export default MarketplaceLink;
